export class PriceUtils {
  public static withVat(price: number, vatPercentage: number) {
    const value = price * (1 + vatPercentage / 100);
    return parseFloat(value.toFixed(2));
  }

  public static withOutVat(price: number, vatPercentage: number) {
    const value = price / (1 + vatPercentage / 100);
    return parseFloat(value.toFixed(2));
  }

  public static rounded(price: number, decimals: number) {
    if (typeof price === 'string') return;
    return price.toFixed(decimals);
  }

  public static priceToCents(price: number, decimals: number = 2): number {
    const factor = Math.pow(10, decimals);
    return Math.round(price * factor);
  }
}
